import React from 'react'
import { browserHistory } from 'react-router';
import NavLink from '../Routes/NavLink'
import moment from 'moment'

import { properties } from '../../core/controllers/Properties'
import { user } from '../../core/controllers/user'

export default class PropertyCards extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            properties: null,
            isOwner: false,
            listView: false
        };

        this.lastSortID = 0;
        this.index = 0;
    }

    componentDidMount() {
        var self = this;
        user.getUserDataWithCallback(function(userData) {
            if (user.userInfo.user_type_alias == "owner") {
                properties.getProperties(self.lastSortID, function(response) {
                    self.setState({
                        properties: response.data,
                        isOwner: true
                    });
                });
            } else {
                properties.getProperties(self.lastSortID, function(response) {
                    self.setState({
                        properties: response.data,
                        isOwner: false
                    });
                });
            }
        });
    }

    componentWillUpdate(nextProps, nextState) {
        if(this.lastSortID != nextProps.sortID) {
            this.lastSortID = nextProps.sortID;
            properties.getProperties(this.lastSortID, function(response) {
                self.setState({properties: response.data})
            });
        }
    }

    formatIndexColumn(cell, row) {
        ++this.index;
        return this.index;
    }

    formatActionOptions(cell, row) {
        return (
            <span>
            <NavLink to={/properties/ + row.property_id}><i class="tooltip_custom pull-right fa fa-pencil-square-o">
                <span data-toggle="tooltip" data-placement="bottom" data-original-title="Edit Property" title="" class=""></span>
                </i>
            </NavLink>
            { row.pending != undefined && (
                <span class="important-small-blue"></span>
            )}
            </span>
        )
    }

    formatUnits(cell, row) {
        return (
            <span>{row.units_tally}</span>
        )
    }

    formatDate(date) {
        if(date) {
            return moment(date).format('MMMM Do YYYY');
        } else {
            return 'Not Set';
        }
    }

    editProperty() {
        browserHistory.push('/properties/' + this.details.property_id);
    }

    toggleListView = (isList) => {
        this.setState({
            listView: isList
        })
    }

    formatUnits(cell, row) {
        return (
            <span>{row.units_tally}</span>
        )
    }

    formatDate(cell, row) {
        if(cell) {
            return moment(cell).format('MMMM Do YYYY');
        } else {
            return 'Not Set';
        }
    }

    formatPhoto(cell, row) {
        if(cell != null) {
            return(
                <img 
                    src={cell}
                    style={{
                        objectFit: "cover",
                        width: "232px",
                        height: "94px"
                    }}
                />
            )
        } else {
            return(
                <div
                    style={{
                        width: "232px",
                        height: "94px",
                        textAlign: "center",
                        backgroundColor: "#f5f5f7",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center"
                    }}
                >
                    <span>No cover photo.</span>
                </div>
            )
        }
    }

    didSelectRow(row) {
        browserHistory.push('/properties/' + row.property_id);
    }

    render(){
        var self = this;
        const options = {
            onRowClick: this.didSelectRow,
            sizePerPage: 25
        };
        var properties = this.state.properties;
        const isOwner = this.state.isOwner;
        var propCards = [];
        if(properties != null) {
            propCards = properties.map(function(property) {
                var propertyType = property.details.property_type;
                if (propertyType.includes("/")) {
                    propertyType = propertyType.replace(/\//g, " / ")
                }
                return (
                    <div
                        style={{
                            cursor: "pointer",
                            width: "100%",
                            height: "100%",
                            display: "flex",
                            flexDirection: "column",
                        }}
                        key={property.details.property_id}
                        onClick={self.editProperty.bind(property)}
                    >
                        {property.photo == null ? (
                            <div class="property-photo">
                                <p>No cover image.</p>
                            </div>
                        ) : (
                            <div class="property-photo">
                                <img src={property.photo.url} width="100%" />
                            </div>
                        )}
                        <div class="property-details">
                            <div class="header">
                                <h4 class="title">{property.details.property_name}</h4>
                                <p class="category">{property.details.property_address}<br/>{property.details.property_city} {property.details.property_state}, {property.details.property_zip}</p>
                            </div>
                            <div class="content">
                                <div class="footer">
                                    <div class="legend">
                                        <div>
                                        <i class="pe-7s-home text-info"></i> {propertyType}
                                        </div>
                                    </div>
                                    <hr/>
                                    <div class="stats">
                                        <i class="fa fa-clock-o"></i> Created {self.formatDate(property.details.created_at)}
                                        { property.units_tally > 0 && (
                                            <span>
                                            &nbsp;&nbsp;<i class="icon-unit-box"></i> {property.units_tally} unit{property.units_tally > 1 && "s"}
                                            </span>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            });
        }

        return (
            <div class="content" >
                <div class="row">
                    <div class=" col-md-12">
                        {properties != null ? (
                            <div>
                                <div class="col-md-3 col-sm-6 col-xs-12">
                                    <span class="main-page-header-title">Properties</span>
                                </div>
                                {isOwner == false && (
                                <div class="col-md-2 col-md-offset-7 col-sm-6 col-xs-12">
                                    <NavLink to={"/properties/new"}>
                                        <button type="button" id="add-property" data-loading-text="Loading..." class="btn btn-info btn-fill pull-right" autoComplete="off">
                                            Add Property
                                        </button>
                                        <div class="clearfix"></div>
                                    </NavLink>
                                </div>
                                )}
                            </div>
                        ) : (
                            <div>
                                <div style={{textAlign: "center"}}>
                                    <div class="row">
                                        <span class="main-page-header-title">No Properties Yet</span>
                                    </div>
                                    {isOwner == false && (
                                    <div class="row" style={{marginTop: "10px"}}>
                                        <NavLink to={"/properties/new"}>
                                            <button type="button" id="add-property" data-loading-text="Loading..." class="btn btn-info btn-fill" autoComplete="off">
                                                Add Property
                                            </button>
                                            <div class="clearfix"></div>
                                        </NavLink>
                                    </div>
                                    )}
                                </div>
                                <div class="col-md-12" style={{backgroundImage: "url('/assets/img/properties.png')", backgroundRepeat: 'no-repeat', backgroundPosition: 'bottom', backgroundSize: '55%', minHeight: '560px'}}></div>
                            </div>
                        )}
                    </div>
                </div>
                {properties != null && (
                    <div class="row">
                        <div class="col-md-2 col-sm-3 col-xs-7">
                            <div
                                class="btn-group"
                                style={{ whiteSpace: "nowrap", width: "100%" }}
                            >
                                <button
                                    type="button"
                                    class={
                                      `btn btn-icon btn-info btn-fill property-view-btn
                                    ${this.state.listView ? "active" : ""}`
                                    }
                                    onClick={this.toggleListView.bind(this, true)}
                                    style={{
                                        marginRight: "0px",
                                        paddingRight: "0px",
                                        width: "50%"
                                    }}
                                >
                                    List
                                </button>
                                <button
                                    type="button"
                                    class={
                                        `btn btn-icon btn-info btn-fill pull-right property-view-btn
                                    ${!this.state.listView ? "active" : ""}`
                                    }
                                    onClick={this.toggleListView.bind(this, false)}
                                    style={{
                                        margin: 0,
                                        width: "50%"
                                    }}
                                >
                                    Grid
                                </button>
                            </div>
                        </div>
                    </div>
                )}
                <br/>
                { properties != null && !this.state.listView && (
                    <div class="prop-grid">
                        {propCards}
                    </div>
                )}
                { properties != null && this.state.listView && (
                    <div class="card">
                        <div class="content">
                            {window.matchMedia('(max-width: 991px)').matches ? (
                                <BootstrapTable
                                    data={properties.map(p => {
                                        return({
                                            property_photo: p.photo !== null ? p.photo.url : null,
                                            property_fee: p.fee !== null ? p.fee.fee_title : 'No Fee',
                                            property_owner: p.owner !== null ? p.owner.name : 'No Owner',
                                            ...p.details
                                        })
                                    })}
                                    version='4'
                                    striped
                                    pagination
                                    hover
                                    options={options}
                                >
                                    <TableHeaderColumn dataField='property_id' isKey={ true } hidden/>
                                    <TableHeaderColumn dataField='property_name' dataSort={ true }>Name</TableHeaderColumn>
                                    <TableHeaderColumn dataField='property_address' dataSort={ true }>Address</TableHeaderColumn>
                                    <TableHeaderColumn dataField='property_owner' dataSort={ true }>Owner</TableHeaderColumn>
                                </BootstrapTable>
                            ) : (
                                <BootstrapTable
                                    data={properties.map(p => {
                                        return({
                                            property_photo: p.photo !== null ? p.photo.url : null,
                                            property_fee: p.fee !== null ? p.fee.fee_title : 'No Fee',
                                            property_owner: p.owner !== null ? p.owner.name : 'No Owner',
                                            ...p.details
                                        })
                                    })}
                                    version='4'
                                    striped
                                    pagination
                                    hover
                                    options={options}
                                >
                                    <TableHeaderColumn dataField='property_id' isKey={ true } hidden/>
                                    <TableHeaderColumn dataField='property_photo' dataFormat={this.formatPhoto} width={250}/>
                                    <TableHeaderColumn dataField='property_name' dataSort={ true }>Name</TableHeaderColumn>
                                    <TableHeaderColumn dataField='property_address' dataSort={ true }>Address</TableHeaderColumn>
                                    <TableHeaderColumn dataField='property_type' dataSort={ true }>Type</TableHeaderColumn>
                                    <TableHeaderColumn dataField='created_at' dataFormat={this.formatDate} dataSort={ true }>Date Created</TableHeaderColumn>
                                    <TableHeaderColumn dataField='property_fee' dataSort={ true }>Fee</TableHeaderColumn>
                                    <TableHeaderColumn dataField='property_owner' dataSort={ true }>Owner</TableHeaderColumn>
                                </BootstrapTable>
                            )}
                        </div>
                    </div>
                )}
            </div>
        )
    }
};



// WEBPACK FOOTER //
// app/components/Properties/PropertyCards.jsx